import React from 'react';
import styles from './annotationsSidebar.scss';
import storeManager from '../../store/StoreManager';
import sessionActions from '../../actions/SessionActions';
import { t } from '../../services/i18nService';
import annotationService from '../../services/AnnotationService';
import studentHighlightsActions from '../../actions/StudentHighlightsActions';

const CloseSidebarButton = () => {
    const store = storeManager.getStore();
    const closeSidebar = () => {
        annotationService.dispatchFocusAnnotationEvent(null);
        store.dispatch(studentHighlightsActions.setFocusedAnnotation(null));
        store.dispatch(sessionActions.setAnnotationsSidebarOpen(false));
    };

    return (<button
        className={styles.annotationsHeaderButton}
        id="annotationsCloseButton"
        aria-label={t('header.closeSidebarButtonLabel')}
        onClick={closeSidebar}
    >
        <i className="fa fa-close fa-3" aria-hidden="true" />
    </button>);
};

export default CloseSidebarButton;
